import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dot-spinner',
  templateUrl: './dot-spinner.component.html',
  styleUrls: ['./dot-spinner.component.css']
})
export class DotSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
